import { subHeadingType } from '../../types/components'
import { SubHeaderWrapper, SubHeaderText } from './style'

const SubHeadingInfo = ({
	votingAvailable,
	alreadyParticipated,
	SUB_HEADING,
	CLOSED_SUB_HEADING,
	VOTED_ALREADY_SUB_HEADING,
}: subHeadingType) => {
	const currentHeading = votingAvailable
		? CLOSED_SUB_HEADING
		: alreadyParticipated
		? VOTED_ALREADY_SUB_HEADING
		: SUB_HEADING
	return (
		<SubHeaderWrapper>
			{currentHeading?.map((line, index) => (
				<SubHeaderText key={index}>{line}</SubHeaderText>
			))}
		</SubHeaderWrapper>
	)
}

export default SubHeadingInfo
